import $ from 'jquery'
import lazy_image from 'helpers/lazy_image'

$(function() {
    $('[data-lazy-image]').each(function(){
        const i = new lazy_image(this, $(this).data('lazy-image'))
    });
});